// const BASE_URL = process.env.REACT_APP_ASSETS_BASE_URL;
const BASE_URL="https://krumago-application-assets.s3.us-east-1.amazonaws.com/Institution+Domain+Assets/";
// const BASE_URL="https://krumago-application-assets.s3.us-east-1.amazonaws.com/Institution+Domain+Assets/";

export const INSTITUTION_ASSETS = {
    VIDEO_BACKGROUND: `${BASE_URL}bgVideos/video2.mp4`,
    MAINPAGE_IMAGES: {
        IMAGE_1: `${BASE_URL}admission/img3.jpeg`,
    },
    ADMISSION_IMAGES: {
        IMAGE_1: `${BASE_URL}admission/12.jpeg`,
        IMAGE_2: `${BASE_URL}admission/13.jpeg`,
        IMAGE_3: `${BASE_URL}admission/2.jpeg`,
        IMAGE_4: `${BASE_URL}admission/6.jpeg`,
    },
    SUCCESS_STORIES_IMAGES: {
        BULB: `${BASE_URL}SuccessStories/bulb.png`,
        IMAGE_1: `${BASE_URL}SucessStories/im4.jpeg`,
        IMAGE_2: `${BASE_URL}SucessStories/img1.jpeg`,
        IMAGE_3: `${BASE_URL}SucessStories/img2.jpeg`,
        IMAGE_4: `${BASE_URL}SucessStories/img3.jpeg`,
        IMAGE_5: `${BASE_URL}SucessStories/img5.jpeg`,
        IMAGE_6: `${BASE_URL}SucessStories/section1.png`,
        IMAGE_7: `${BASE_URL}SucessStories/feedback.png`
    },
};